import { useState, useEffect } from "react";
import "../../assets/scss/libs/editors/quill.scss";

// import AWS from "aws-sdk";
import { Card, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../layout/default";

import Block from "../../components/Block/Block";
import CircularProgress from "@mui/material/CircularProgress";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import FormControl from "@mui/material/FormControl";
// import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
// import Stack from "@mui/material/Stack";
//import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//import dayjs from "dayjs";
import { successMessage, failedMessage } from "../utilities/alert-config";
//import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
//import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import //Select,
//Quill,
//FileUpload,
//Tags,
//ImageUpload,
//DatePicker,
// Tinymce,
// {Icon} from
"../../components";
import { rootURL } from "../utilities/axios-config";
// import Checkbox from "@mui/material/Checkbox";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const Input = styled("input")({
//   display: "none",
// });

function EditAbout() {
  const { id } = useParams();
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [company_name, setcompany_name] = useState("");
  const [about_info, setabout_info] = useState("");
  const [location, setlocation] = useState("");
  const [contact_number, setcontact_number] = useState("");
  const [contact_email, setcontact_email] = useState("");
  const [facebook_page, setfacebook_page] = useState("");
  const [twitter_page, settwitter_page] = useState("");
  const [instagram_page, setinstagram_page] = useState("");
  const [youtube_page, setyoutube_page] = useState("");


  const [loading2, setloading2] = useState(false);

  const tableActorShow = async () => {
    try {
      const userToken = localStorage.getItem("userToken");
      const config = {
        headers: {
          Authorization: `Bearer ${userToken}`,
          "Content-Type": "application/json",
        },
      };
      let url = `${rootURL}/aboutshow/${id}`;
      setLoading(true);
      fetch(url, config)
        .then((row) => row.json())
        .then((row) => {
          if (row?.success === true) {
            setcompany_name(row?.data?.company_name);
            setabout_info(row?.data?.about_info);
            setlocation(row?.data?.location);
            setcontact_number(row?.data?.contact_number);
            setcontact_email(row?.data?.contact_email);
            setfacebook_page(row?.data?.facebook_page);
            settwitter_page(row?.data?.twitter_page);
            setinstagram_page(row?.data?.instagram_page);
            setyoutube_page(row?.data?.youtube_page ?? "");
      
          

            setLoading(false);
          } else if (row?.success === false) {
            setLoading(false);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    tableActorShow();
    // eslint-disable-next-line
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userToken = localStorage.getItem("userToken");
    setloading2(true);
    const actorObj = {
      id,
      company_name,
      about_info,
      location,
      contact_number,
      contact_email,
      facebook_page,
      twitter_page,
      instagram_page,
      youtube_page
    };

    fetch(`${rootURL}/updateabout`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${userToken}`,
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(actorObj),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success === true) {
          successMessage("Success");

          setTimeout(() => {
            history("/configuration-manage/about-list");
          }, 3000);
        } else if (result.success === false) {
          setloading2(false);
          failedMessage(result.message);
        }
      })
      .catch((error) => {
        setloading2(false);
        failedMessage("Internal Server Error");
      })
      .finally(() => {
        setloading2(false);
      });
  };

  return (
    <>
      {loading ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress size={70} thickness={4} />
          </div>
        </>
      ) : (
        <>
          <Layout title="Edit About" content="container">
            <Block.Head>
              <Block.HeadBetween>
                <Block.HeadContent>
                  <Block.Title tag="h2">Edit About</Block.Title>
                  <nav>
                    <ol className="breadcrumb breadcrumb-arrow mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/configuration-manage/about-list">
                        About
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Edit About
                      </li>
                    </ol>
                  </nav>
                </Block.HeadContent>
              </Block.HeadBetween>
            </Block.Head>

            <Block>
              <Form onSubmit={handleSubmit}>
                <Row className="g-gs">
                  <Col xxl="9">
                    <div className="gap gy-4">
                      <div className="gap-col">
                        <Card className="card-gutter-md">
                          <Card.Body>
                            <Row className="g-gs">
                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="company_name">
                                    Company Name *
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      type="text"
                                      id="company_name"
                                      placeholder="Company Name"
                                      value={company_name}
                                      required
                                      onChange={(e) =>
                                        setcompany_name(e.target.value)
                                      }
                                    />
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="about_info">
                                    About Info
                                  </Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="About Info"
                                      value={about_info}
                                      onChange={(e) =>
                                        setabout_info(e.target.value)
                                      }
                                    />
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="location">Location</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Location"
                                      value={location}
                                      onChange={(e) => setlocation(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="contact_number">Contact Number</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Contact Number"
                                      value={contact_number}
                                      onChange={(e) => setcontact_number(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>


                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="contact_email">Contact Email</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Contact Email"
                                      value={contact_email}
                                      onChange={(e) => setcontact_email(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="facebook_page">Facebook Page Link</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Facebook Page Link"
                                      value={facebook_page}
                                      onChange={(e) => setfacebook_page(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="twitter_page">Twitter Page Link</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Twitter Page Link"
                                      value={twitter_page}
                                      onChange={(e) => settwitter_page(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>


                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="instagram_page">Instagram Page Link</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Instagram Page Link"
                                      value={instagram_page}
                                      onChange={(e) => setinstagram_page(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>


                              <Col lg="12">
                                <Form.Group className="form-group">
                                  <Form.Label htmlFor="youtube_page">Youtube Page Link</Form.Label>
                                  <div className="form-control-wrap">
                                    <Form.Control
                                      as="textarea"
                                      rows="2"
                                      placeholder="Youtube Page Link"
                                      value={youtube_page}
                                      onChange={(e) => setyoutube_page(e.target.value)}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>

                            </Row>
                          </Card.Body>
                        </Card>
                      </div>

                      <div className="gap-col">
                        <ul className="d-flex align-items-center gap g-3">
                          <li>
                            <Button type="submit" variant="contained">
                              {loading2 ? "Updating...." : "Update"}
                            </Button>
                          </li>
                          <li>
                            <Link
                              to="/configuration-manage/about-list"
                              className="btn border-0"
                            >
                              Cancel
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Block>
          </Layout>
        </>
      )}
    </>
  );
}

export default EditAbout;
